/**
 * SpreadsheetSlider components
 * @fileoverview Styled-components used only inside SpreadsheetSlider
 */

import styled, { css } from 'styled-components';

import { colorTokens } from '../../../../tokens/globals/tokens';
import resets from '../../../../assets/styled/resets';
import { StyledIcon } from '../../../../components/Icon/Icon';

export const SLIDER_SLIDING_ANIMATION_LENGTH_MS = 200;

export const SpreadsheetSliderWrapper = styled.div`
  background-color: ${colorTokens.GlobalBrandWhite};
  border-left: 1px solid ${colorTokens.GlobalBrandGray40};
  border-top: 1px solid ${colorTokens.GlobalBrandGray40};
  bottom: 0;
  display: flex;
  grid-column: 2;
  grid-row: ${({ theme }) => (theme.hasMenu ? 2 : 1)};
  transition: all ${SLIDER_SLIDING_ANIMATION_LENGTH_MS}ms ease-in-out;
  z-index: 182;
  overflow-y: auto;
`;

export const SpreadsheetSliderHeader = styled.div`
  align-items: center;
  color: ${colorTokens.GlobalBrandGray60};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 60px;
`;

export const SpreadsheetSliderContent = styled.div`
  border-left: 1px solid ${colorTokens.GlobalBrandGray40};
  overflow-y: auto;
  padding: 20px 20px 0;
  position: relative;
  width: 100%;
`;

export const SpreadsheetSliderToogle = styled.button`
  ${resets.BrowserButton}
  color: ${colorTokens.GlobalBrandGray50};
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  margin: 16px 0;
  position: relative;
  text-align: center;
  transition: color 60ms ease-in;
  transition: transform 140ms ease-in;
  width: 59px;

  ${StyledIcon} svg {
    position: relative;
    z-index: 100;
  }

  ${({ theme }) =>
    theme.open &&
    css`
      transform: rotate(180deg);
      transform-origin: center;
      color: ${colorTokens.GlobalBrandGray90};
    `}

  &:hover {
    color: ${colorTokens.GlobalBrandGray80};
    ${StyledIcon} svg {
      transition: all 60ms ease-in;
      transform: translateX(-3px);
    }
  }

  ${props =>
    !props.children &&
    css`
      height: 100%;
    `}
`;

export const SpreadsheetSliderTabs = styled.div`
  position: relative;
  padding-top: 9px;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    height: 1px;
    display: block;
    color: ${colorTokens.GlobalBrandGray40};
    border-bottom: 1px solid ${colorTokens.GlobalBrandGray40};
    right: 12px;
    left: 12px;
    top: 0;
  }
`;

// TO DO: https://carta1.atlassian.net/browse/INK-819
// This button is used for FullPageSpreadsheetV2's close button
// and the tab options in the Spreadsheet slider. It has to be
// 58px + 2px margin (top and bottom) because the sticky header
// has a border around it.
export const SpreadsheetSliderTabButton = styled.button`
  ${resets.BrowserButton}
  cursor: pointer;
  position: relative;
  width: 58px;
  height: 58px;
  margin: 1px 1px 1px 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 60ms ease-in;

  &::after {
    content: '';
    position: absolute;
    width: 42px;
    height: 42px;
    border-radius: 3px;
    z-index: 98;
    transition: all 60ms ease-in;
  }

  &:hover {
    color: ${colorTokens.GlobalBrandGray80};
    &::after {
      background-color: ${colorTokens.GlobalBrandGray30};
    }
  }

  ${({ theme }) =>
    theme.active &&
    css`
      color: ${colorTokens.GlobalBrandGray80};
      &::after {
        background-color: ${colorTokens.GlobalBrandGray30};
      }
      &:hover {
        color: ${colorTokens.GlobalBrandGray90};
        &::after {
          background-color: ${colorTokens.GlobalBrandGray40};
        }
      }
    `}

  ${StyledIcon} svg {
    position: relative;
    z-index: 100;
  }
`;
